/** @file liveChordState: the key tables and the user's overrides every menu reads its chord labels from. */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

/** Mutable on purpose: `App` keeps it equal to the tables it registers, so a label is never typed by hand. */
export const liveChordState: { tables: Binding[][]; overrides: Binding[] } = { tables: [], overrides: [] };
